@if (firmen$ | async; as firmen) {
  <div class="flex flex-col flex-nowrap">
    <h6 class="font-semibold">Firma</h6>
    <soft-select [value]="(selectedFirmaId$ | async)" (valueChange)="onChange($event)">
      @for (firma of firmen; track firma) {
        <soft-select-option
          [value]="firma.id">
          {{ firma?.kurzbezeichnung }}
        </soft-select-option>
      }
    </soft-select>
  </div>
}
